import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixToast from '@radix-ui/react-toast';
import { X } from 'lucide-react';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import styles from './Toast.module.css';
const ToastContext = createContext(null);
let nextId = 0;
/** Fournit `useToast()` à toute l'application ; monte le viewport une seule fois. */
export function ToastProvider({ children }) {
    const [entries, setEntries] = useState([]);
    const toast = useCallback((options) => {
        const id = nextId++;
        setEntries((current) => [...current, { ...options, id }]);
    }, []);
    const remove = useCallback((id) => {
        setEntries((current) => current.filter((entry) => entry.id !== id));
    }, []);
    const value = useMemo(() => ({ toast }), [toast]);
    return (_jsx(ToastContext.Provider, { value: value, children: _jsxs(RadixToast.Provider, { swipeDirection: "down", children: [children, entries.map((entry) => (_jsxs(RadixToast.Root, { className: styles.root, "data-tone": entry.tone ?? 'default', duration: entry.durationMs ?? 5000, onOpenChange: (open) => {
                        if (!open)
                            remove(entry.id);
                    }, children: [_jsxs("div", { children: [_jsx(RadixToast.Title, { className: styles.title, children: entry.title }), entry.description ? (_jsx(RadixToast.Description, { className: styles.description, children: entry.description })) : null] }), _jsx(RadixToast.Close, { className: styles.close, "aria-label": entry.closeLabel, children: _jsx(X, { size: 16, strokeWidth: 1.5, "aria-hidden": "true" }) })] }, entry.id))), _jsx(RadixToast.Viewport, { className: styles.viewport })] }) }));
}
/** Déclenche un toast depuis n'importe quel composant enfant de `ToastProvider`. */
export function useToast() {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast doit être utilisé à l’intérieur de <ToastProvider>.');
    }
    return context;
}
//# sourceMappingURL=Toast.js.map